import Link from "../link/link";

interface Props {
  currentPage: number;
  totalPages: number;
  getPageHref: (page: number) => string;
  delta?: number;
}

const PaginationNumbers = ({
  currentPage,
  totalPages,
  getPageHref,
  delta = 1,
}: Props) => {
  const getItems = () => {
    const start = Math.max(1, currentPage - delta);
    const end = Math.min(totalPages, currentPage + delta);

    let lastRendered: number | null = null;

    const items = [];
    for (let i = start; i <= end; i++) {
      if (i === start && start > 1) {
        items.push(
          <span key={`ellipsis-start`} className="px-2 py-2">
            ...
          </span>,
        );
      }

      const isActive = i === currentPage;

      items.push(
        isActive ? (
          <span
            key={i}
            className="rounded-md bg-[#373B37] px-2 py-2 font-normal text-white"
          >
            {i}
          </span>
        ) : (
          <Link
            key={i}
            href={getPageHref(i)}
            className="rounded-md px-2 py-2 text-sm !font-normal hover:bg-gray-200 lg:px-4"
          >
            {i}
          </Link>
        ),
      );

      lastRendered = i;
    }

    if (end < totalPages) {
      items.push(
        <span key={`ellipsis-end`} className="px-2 py-2">
          ...
        </span>,
      );
    }

    return items;
  };

  const items = getItems();

  return items;
};

export default PaginationNumbers;
